export enum UITextTypes {
  title = "title",
  label = "label",
  labelTooltip = "labelTooltip",
  fieldInfo = "fieldInfo",
  titleTooltip = "titleTooltip",
}
